import React, { useEffect, useState } from 'react';
import ReGridviewPanelTab from '@components/ReGridviewPanelTab';
import ReListViewPanelTab from '@components/ReListViewPanelTab';
import { useStoreProduct } from '@state/useStoreProduct';
import { useStoreCategory } from '@state/useStoreCategory';

const ItemProductTab = () => {
  const { flatProducts } = useStoreProduct((state) => ({
    flatProducts: state.flatProducts,
  }));
  const [selectedProduct, setSelectedProduct] = useState();

  const { activeSection } = useStoreCategory((state) => ({
    activeSection: state.activeSection,
  }));

  // Also when the menu data changes (e.g. a sold-out refusal marked products sold out),
  // not only on a tab switch — otherwise the tab keeps drawing them as orderable.
  useEffect(() => {
    const tabIndex = activeSection;
    setSelectedProduct(flatProducts[tabIndex]);
  }, [activeSection, flatProducts]);

  // key used for render item from the top position
  return (
    <>
      {selectedProduct &&
        (selectedProduct.menu_type === 'grid' ? (
          <ReGridviewPanelTab category={selectedProduct} key={activeSection} />
        ) : (
          <ReListViewPanelTab category={selectedProduct} key={activeSection} />
        ))}
    </>
  );
};

export default ItemProductTab;
